import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';
import { useStewardshipStore } from '../../../store/useStewardshipStore';
import { TableStewardshipLoading } from '../TableLoading';
import { TableAgrotechEventList } from './table/TableAgrotechEventList';
import { NavigateTitle } from '../../navigate-title/NavigateTitle';
import { StatisticsCard } from '../../header/StatisticsCard';
import useStore from '@/lib/store';

export const StewardshipAgrotechEventList: FC = () => {
  const [searchParams] = useSearchParams();
  const plant_id = searchParams.get('plant_id');
  const farmer_type = searchParams.get('farmer_type') as string;
  const { employee_id, district_id, region_id } = useParams();
  const { t } = useTranslation();
  const { plants } = useStore();

  const {
    employeeActions,
    employeeActionsLoading,
    fetchEmployeeActions,
  } = useStewardshipStore();

  useEffect(() => {
    if (employee_id && plant_id && district_id) {
      fetchEmployeeActions({ employee_id, plant_id, district_id, farmer_type });
    }
  }, [employee_id, plant_id, district_id, farmer_type]);

  const selectedPlant = useMemo(() => {
    return plants?.find((plant) => plant.id === plant_id);
  }, [plants, plant_id]);

  const employeeName = useMemo(() => {
    if (!employeeActions) return undefined;
    const parts = [
      employeeActions.last_name,
      employeeActions.first_name,
      employeeActions.middle_name,
    ].filter(Boolean);
    return parts.join(' ');
  }, [employeeActions]);

  return (
    <div className="flex flex-col gap-4 p-8 h-full">
      <div className="flex items-center justify-between flex-shrink-0">
        <div className="flex items-center gap-5">
          <p className="text-xl font-semibold">
            {employeeName} {employeeActions?.region_name} {employeeActions?.district_name} {t('responsible.employee')}
          </p>
        </div>
        {employeeActions && selectedPlant && (
          <div className="flex gap-2">
            <StatisticsCard
              icon={null}
              label={t('farmers.count')}
              count={Number(employeeActions.farmers_count)}
              countColor="text-green-green-700"
            />
            <StatisticsCard
              icon={null}
              label={t('projects.count')}
              count={Number(employeeActions.projects_count)}
              countColor="text-dark-blue-300"
            />
          </div>
        )}
      </div>
      <div className="flex-1 overflow-hidden">
        {employeeActionsLoading ? (
          <TableStewardshipLoading />
        ) : employeeActions ? (
          <TableAgrotechEventList data={employeeActions} />
        ) : (
          <div className="w-full h-full flex justify-center items-center">
            <h2 className="text-2xl text-gray-500">{t('no.data')}</h2>
          </div>
        )}
      </div>
    </div>
  );
};

